<!-- Topbar Start -->
<div class="navbar-custom" style="background-color: #1F2A47">
    <div class="container-fluid">
        <!-- LOGO -->
        <div class="logo-box">
            <a href="#/admin/dashboard" class="logo logo-light text-center">
                <span class="logo-lg">
                    <img src="/assets/images/logo_siipne.png" alt="" height="40">
                </span>
                <span class="logo-sm">
                    <img src="/assets/images/icono_siipne.png" alt="" height="40">
                </span>
            </a>
        </div>

        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
                <button id="btn-collapsed" class="button-menu-mobile waves-effect waves-light">
                    <i class="fe-menu"></i>
                </button>
            </li>
            <!-- <li class="pt-3 col-4">
                <form [formGroup]="formSelectRolAmbiente">
                    <select class="form-group" class="form-select form-select-sm" formControlName="idSprRolAmbiente" 
                    (change)="changeRolAmbienteSelected($event)" >
                    <option *ngFor="let row of dataUsuarioRolesAmbientes" 
                    value={{row.idSprRol}}*{{row.idSprAmbiente}}*{{row.nombreUnidad}}*{{row.idSprNivel}}>
                    {{row.nombre}} / {{row.nombreUnidad}} - [{{row.nivel}}]       
                    </select>
                </form>
            </li> -->

            <li class="pt-3 col-4">
                <form [formGroup]="formSelectRolAmbiente">
                    <select class="form-group" class="form-select form-select-sm" formControlName="idSprRolAmbiente" (change)="changeRolAmbienteSelected($event)">
                        <option *ngFor="let row of dataUsuarioRolesAmbientes"
                            value={{row.idSprRol}}*{{row.ambiente.idSprAmbiente}}*{{row.ambiente.nombreUnidad}}*{{row.ambiente.nivel.idSprNivel}}>
                            {{row.nombre}} / {{row.ambiente.nombreUnidad}} - [{{row.ambiente.nivel.nombre}}]
                    </select>
                </form>
            </li>
        </ul>
        <!--  <ul class="list-unstyled topnav-menu pt-3">   -->
        <!--  </ul> -->

        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li *ngIf="(idSprRolPrincipal == idRolObservador) || (idSprRolPrincipal == idRolAnalistaMetodologico)" class="pt-3 col-2">
                <button type="button " tooltip="Editar " class="btn btn-sm btn-link waves-effect rounded-pill " title="Observador" (click)="openModal()">
                    <i class="fas fa-2x fa-eye fa-lg  " style="color: aliceblue"></i>
                </button>
            </li>
        </ul>

        <ul class="list-unstyled topnav-menu float-end mb-0">


            <!-- ITEM PARA NOTIFICACIONES -->
            <li class="dropdown notification-list pt-2">
                <div class="noti-title">
                    <h6 class="text-white m-0" *ngIf="currentUserRedux">{{currentUserRedux.nombreUsuario}}</h6>
                </div>
                <!-- <a class="nav-link dropdown-toggle waves-effect waves-light" data-bs-toggle="dropdown" href="#"
                    role="button" aria-haspopup="false" aria-expanded="false">
                    <i class="fe-bell noti-icon"></i>
                    <span class="badge bg-danger rounded-circle noti-icon-badge">5</span>
                </a> -->
                <!-- <div class="dropdown-menu dropdown-menu-end dropdown-lg"> -->
                <!-- item-->
                <!-- <div class="dropdown-item noti-title">
                        <h5 class="m-0">
                            <span class="float-end">
                                <a href="" class="text-dark">
                                    <small>Limpiar</small>
                                </a>
                            </span>Notificación
                        </h5>
                    </div>
                    <div class="noti-scroll" data-simplebar> -->
                <!-- item-->
                <!-- <a href="javascript:void(0);" class="dropdown-item notify-item active">
                            <div class="notify-icon">
                                <img src="/assets/images/paquito.jpg" class="img-fluid rounded-circle" alt="" />
                            </div>
                            <p class="notify-details">Título Notificación</p>
                            <p class="text-muted mb-0 user-msg">
                                <small>Breve detalle</small>
                            </p>
                        </a>  -->
                <!-- item-->
                <!-- <a href="javascript:void(0);" class="dropdown-item notify-item">
                            <div class="notify-icon bg-warning">
                                <i class="mdi mdi-account-plus"></i>
                            </div>
                            <p class="notify-details">Usuarios registrados.
                                <small class="text-muted">Hace 5 horas</small>
                            </p>
                        </a>
                    </div>  -->
                <!-- All-->
                <!-- <a href="javascript:void(0);" class="dropdown-item text-center text-primary notify-item notify-all">
                        View all
                        <i class="fe-arrow-right"></i>
                    </a>
                </div> -->
            </li>
            <!-- ITEM PARA EL USUARIO LOGUEADO -->
            <li class="dropdown notification-list topbar-dropdown">
                <a id="dropdown" class="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                    <img src="/assets/images/paquito.jpg" alt="user-image" class="rounded-circle">
                    <span class="pro-user-name ms-1"> </span>
                    <i class="mdi mdi-chevron-down"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-end profile-dropdown">
                    <!-- item-->
                    <div class="dropdown-header noti-title">
                        <h6 class="text-overflow m-0" *ngIf="currentUserRedux">{{currentUserRedux.nombreUsuario}}</h6>
                    </div>

                    <!-- <a href="#" class="dropdown-item notify-item">
                        <i class="fe-user"></i>
                        <span> <small> Mi Perfil</small></span>
                    </a> -->
                    <!-- item-->
                    <a (click)="logout()" class="dropdown-item notify-item" href="#">
                        <i class="fe-log-out"></i>
                        <span> <small> Cerrar Sesión </small></span>
                    </a>

                </div>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>
<!-- end Topbar -->

<jw-modal id="{{nameModalObservador}}">
    <!-- MODAL PARA CREAR Y EDITAR -->
    <div class="modal-dialog" style="padding-top:8%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="closeModal();" aria-label="Close"></button>
            </div>
            <app-observador></app-observador>
        </div>
    </div>
</jw-modal>